class AddressSuggestionSerializer {
  static deSerialize(data) {
    if (!data || typeof data !== 'object' || !data.length) {
      return null;
    }
    const firstResult = data[0] || {};
    const street = (firstResult.direccion || {}).calle || {};
    return {
      approximated: firstResult.Aproximada,
      coordinates: {
        latitude: firstResult.puntoY,
        longitude: firstResult.puntoX,
      },
      error: firstResult.error,
      street: {
        name: street.nombre_normalizado,
        id: street.idCalle,
      },
    };
  }
}

export { AddressSuggestionSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/AddressSuggestionSerializer.js